<template>
  <v-container fluid grid-list-md text-xs-center style="min-height: 93.4vh">
    <v-layout row wrap>
      <v-toolbar scroll-target="#scrolling-home" style="z-index: 1" extended>
        <v-toolbar-title style="margin-top: 60px">
          <div class="d-flex align-center justify-center">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x
              v-if="getView()"
              class="d-inline-block"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" large color="gradiente">
                  menu
                </v-icon>
              </template>

              <v-card style="padding: 10px">
                <v-menu
                  ref="dateMenu2"
                  v-model="dateMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  :close-on-content-click="false"
                  :return-value.sync="dates"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      @input="filterDate"
                      v-model="dates"
                      multiple
                      chips
                      small-chips
                      label="Fechas"
                      style="margin-top: 30px"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    locale="es-419"
                    v-model="dates"
                    scrollable
                    multiple
                    no-title
                    :allowed-dates="allowedDatesF"
                    @input="filterDate"
                  >
                    <v-spacer />
                    <v-btn flat color="primary" @click="dateMenu = false">
                      Cancelar
                    </v-btn>
                    <v-btn
                      flat
                      color="primary"
                      @click="$refs.dateMenu2.save(dates)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-select
                  @input="filterType"
                  :items="types"
                  v-model="filters.typeNotice"
                  item-value="value"
                  item-text="text"
                  style="margin-top: 30px"
                  multiple
                  label="Tipo de comunicado"
                />
                <v-select
                  @input="filterStatus"
                  :items="status"
                  v-model="filters.statusNotice"
                  item-value="value"
                  item-text="text"
                  multiple
                  label="Estatus"
                />

                <v-card-actions>
                  <v-spacer />

                  <v-btn text @click="menu = false"> Cancel </v-btn>
                  <v-btn color="primary" text @click="menu = false">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
            <div class="d-inline-block">Comunidad</div>
          </div>
        </v-toolbar-title>
        <v-layout wrap justify-space-around fill-height align-center ml-2>
          <v-flex lg2 md2 v-show="!getView()">
            <v-menu
              ref="dateMenu2"
              v-model="dateMenu"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              :close-on-content-click="false"
              :return-value.sync="dates"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  @input="filterDate"
                  v-model="dates"
                  multiple
                  chips
                  small-chips
                  label="Fechas"
                  style="margin-top: 30px"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker
                header-color="primary"
                color="secondary"
                locale="es-419"
                v-model="dates"
                scrollable
                multiple
                no-title
                :allowed-dates="allowedDatesF"
                @input="filterDate"
                v-show="!getView()"
              >
                <v-spacer />
                <v-btn flat color="primary" @click="dateMenu = false">
                  Cancelar
                </v-btn>
                <v-btn
                  flat
                  color="primary"
                  @click="$refs.dateMenu2.save(dates)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <!-- tipo de noticia -->
          <v-flex lg2 md2 v-show="!getView()">
            <v-select
              @input="filterType"
              :items="types"
              v-model="filters.typeNotice"
              item-value="value"
              item-text="text"
              style="margin-top: 30px"
              multiple
              label="Tipo de comunicado"
            />
          </v-flex>
          <!-- estatus -->
          <v-flex lg2 md2 v-show="!getView()" style="margin-top: 30px">
            <v-select
              @input="filterStatus"
              :items="status"
              v-model="filters.statusNotice"
              item-value="value"
              item-text="text"
              multiple
              label="Estatus"
            />
          </v-flex>
          <v-flex lg4 md4 sm8 xs8>
            <v-layout>
              <v-flex lg11 class="titleSearch">
                <v-text-field
                  flat
                  label="Buscar"
                  append-outer-icon="search"
                  @click:append-outer="filterSearch"
                  @click:clear="clearSearch"
                  @keyup.enter="filterSearch"
                  style="margin-top: 30px"
                  solo-inverted
                  v-model="filters.search"
                  clearable
                />
              </v-flex>
              <v-flex lg1 v-if="isFilterActive">
                <v-img
                  style="
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                    margin-top: 40px;
                  "
                  :src="require('@/assets/notices/clear-filter.png')"
                  @click="clearFilter"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg2 md2 sm4 xs4 v-show="permits['CONFIRM_NOTICE']">
            <v-btn
              flat
              color="primary"
              style="margin-top: 30px"
              @click.stop="drawer = !drawer"
            >
              <div v-if="!this.$vuetify.breakpoint.xsOnly">Pendientes</div>
              <v-badge color="gradiente-m">
                <template v-slot:badge>
                  <span v-if="noticesPend != ''">
                    {{ noticesPend }}
                    <!-- meter aqui el n comunicados pendientes -->
                  </span>
                </template>
                <v-icon large color="gradiente"> event_note </v-icon>
              </v-badge>
            </v-btn>
          </v-flex>
          <v-flex
            v-show="$vuetify.breakpoint.xsOnly && $vuetify.breakpoint.smOnly"
          >
            <v-btn flat color="primary" @click.stop="drawer = !drawer">
              <v-badge color="gradiente">
                <template v-slot:badge>
                  <span>5</span>
                </template>
                <v-icon large color="gradiente"> event_note </v-icon>
              </v-badge>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-tooltip
          right
          v-if="permits['WATCH_NOTICE'] && permits['ADD_NOTICE']"
        >
          <v-btn
            color="gradiente"
            dark
            small
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="modals.createNotice = true"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear comunicado</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="max-height: 75vh"
        class="scrollDesign"
        grid-list-md
      >
        <v-layout row wrap>
          <v-flex
            xs12
            :sm12="permits['CONFIRM_NOTICE']"
            :md12="permits['CONFIRM_NOTICE']"
            :lg12="permits['CONFIRM_NOTICE']"
          >
            <v-data-iterator
              :pagination.sync="pagination"
              :total-items="totalNotices"
              :rows-per-page-items="[9, 18, 27]"
              :items="notices"
              item-key="id"
              content-tag="v-layout"
              :no-data-text="
                permits['WATCH_NOTICE']
                  ? notices.length > 0
                    ? ''
                    : 'No hay comunicados'
                  : 'No tienes permiso de ver comunicados'
              "
              no-results-text="No hay comunicados"
              rows-per-page-text="Registros por página"
              row
              wrap
            >
              <template v-slot:item="props">
                <v-flex xs12 sm8 md8 lg4 xl4>
                  <v-hover>
                    <v-card
                      slot-scope="{ hover }"
                      class="expandableContainer elevation-0"
                    >
                      <v-layout row wrap>
                        <v-flex sm4 md4 lg4>
                          <v-img
                            v-if="props.item.imageStorage.length > 0"
                            :src="props.item.imageStorage[0].miniObjUrl"
                            @click="props.expanded = !props.expanded"
                            class="imgThumCard"
                          />
                          <v-img
                            v-else-if="props.item.type == 'A'"
                            :src="require('@/assets/notices/SKLB-Aviso 3.png')"
                            @click="props.expanded = !props.expanded"
                            class="imgThumCard"
                          />
                          <v-img
                            v-else-if="props.item.type == 'E'"
                            :src="require('@/assets/notices/SKLB-Evento.png')"
                            @click="props.expanded = !props.expanded"
                            class="imgThumCard"
                          />
                          <v-img
                            v-else-if="props.item.type == 'R'"
                            :src="require('@/assets/notices/SKLB-informe.png')"
                            @click="props.expanded = !props.expanded"
                            class="imgThumCard"
                          />
                          <v-img
                            v-else-if="props.item.type == 'P'"
                            :src="require('@/assets/notices/SKLB-Permiso.png')"
                            @click="props.expanded = !props.expanded"
                            class="imgThumCard"
                          />
                        </v-flex>
                        <v-flex sm5 md5 lg5>
                          <div
                            class="text-truncate"
                            style="width: 75%; margin-top: 60px"
                          >
                            <b>{{ props.item.title }}</b>
                          </div>
                        </v-flex>
                        <v-flex sm1 md1 lg1>
                          <v-icon
                            color="primary"
                            @click="viewNotice(props.item)"
                            flat
                            style="margin-top: 50px"
                          >
                            remove_red_eye
                          </v-icon>
                        </v-flex>
                      </v-layout>
                      <v-divider />
                      <v-card-actions>
                        <!-- ---  STATUS CANCELADO --- -->
                        <v-alert
                          class="statusEvent cancelled"
                          outline
                          v-if="
                            props.item.cancelled || props.item.confirm == 'C'
                          "
                          :value="true"
                          color="black"
                          icon="cancel"
                        >
                          <span class="semi-small">Cancelado</span>
                        </v-alert>
                        <!-- ---  STATUS GUARDADO BORRADOR S --- -->
                        <v-alert
                          class="statusEvent saved"
                          outline
                          v-else-if="props.item.confirm == 'S'"
                          :value="true"
                          color="orange"
                          icon="save"
                        >
                          <span class="semi-small">Guardado</span>
                        </v-alert>
                        <!-- ---  STATUS AUTORIZADO/PROGRAMADO A --- -->
                        <v-alert
                          class="statusEvent important"
                          outline
                          v-else-if="props.item.confirm == 'A'"
                          :value="true"
                          color="blue"
                          icon="event"
                        >
                          <span class="semi-small">Programado</span>
                        </v-alert>
                        <!-- ---  STATUS POR (pendient) AUTORIZAR P--- -->
                        <v-alert
                          class="statusEvent to_authorized"
                          outline
                          v-else-if="props.item.confirm == 'P'"
                          :value="true"
                          color="orange"
                          icon="schedule"
                        >
                          <span class="semi-small">Por autorizar</span>
                        </v-alert>
                        <!-- ---  STATUS RECHAZADO R --- -->
                        <v-alert
                          class="statusEvent refused"
                          outline
                          v-else-if="props.item.confirm == 'R'"
                          :value="true"
                          type="error"
                          icon="cancel"
                        >
                          <span class="semi-small">Rechazado</span>
                        </v-alert>
                        <!-- ---  STATUS PUBLICADO I--- -->
                        <v-alert
                          class="statusEvent release"
                          outline
                          v-else-if="props.item.confirm == 'I'"
                          :value="true"
                          type="success"
                        >
                          <span class="semi-small">Publicado</span>
                        </v-alert>
                        <!-- ---  STATUS FINALIZADO F --- -->
                        <v-alert
                          class="statusEvent finish"
                          outline
                          v-else-if="props.item.confirm == 'F'"
                          :value="true"
                          color="blue-grey lighten-1"
                        >
                          <span class="semi-small">Finalizado</span>
                        </v-alert>
                        <v-spacer />
                        <v-btn
                          @click="historyNotice(props.item)"
                          icon
                          v-if="
                            permits['WATCH_NOTICE'] && !props.item.cancelled
                          "
                        >
                          <v-icon>history</v-icon>
                        </v-btn>
                        <!-- si el comunicado tiene status PorAutorizar, no sea rechazado y que el comunicado no esté cancelado, no puede editar -->
                        <v-btn
                          @click="editNotice(props.item)"
                          icon
                          v-if="
                            permits['UPDATE_NOTICE'] &&
                            !props.item.cancelled &&
                            props.item.confirm !== 'P' &&
                            props.item.confirm !== 'R' &&
                            props.item.confirm != 'F'
                          "
                        >
                          <v-icon>edit</v-icon>
                        </v-btn>
                        <!-- ---  BOTON CANCELAR SOLO SE MUESTRa cuando no esta cancelado y es evento--- -->
                        <!-- <v-btn
                          icon
                          @click="cancelModalNotice(props.item)"
                          v-if="!props.item.cancelled && props.item.type == 'E' && props.item.confirm == 'I'"
                        >
                          <v-icon color="primary">
                            cancel
                          </v-icon>
                        </v-btn> -->
                        <!-- old -->
                        <!-- <v-btn
                          icon
                          @click="cancelNotice(props.item)"
                          v-if="!props.item.cancelled && props.item.type == 'P'"
                        >
                          <v-icon color="primary">cancel</v-icon>
                        </v-btn> -->
                        <v-btn
                          v-if="permits['DELETE_NOTICE']"
                          icon
                          @click="
                            deleteModalNotice(props.item)
                            selected.dNotice = props.item
                          "
                        >
                          <v-icon color="red"> delete </v-icon>
                        </v-btn>
                      </v-card-actions>
                      <v-expand-transition>
                        <v-list v-if="props.expanded" dense>
                          <v-list-tile>
                            <v-list-tile-content>Tipo:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <img
                                    v-if="props.item.type == 'A'"
                                    :src="require('@/assets/notices/aviso.png')"
                                  />
                                  <img
                                    v-else-if="props.item.type == 'E'"
                                    :src="
                                      require('@/assets/notices/evento.png')
                                    "
                                  />
                                  <img
                                    v-else-if="props.item.type == 'R'"
                                    :src="
                                      require('@/assets/notices/informe.png')
                                    "
                                  />
                                  <img
                                    v-else-if="props.item.type == 'P'"
                                    :src="
                                      require('@/assets/notices/permiso.png')
                                    "
                                  />
                                </v-avatar>
                                {{ props.item.type | noticeTypeFilter }}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content
                              >Confirmación del Tutor:</v-list-tile-content
                            >
                            <v-list-tile-content class="align-end">
                              <v-icon
                                v-if="props.item.confirmParent"
                                color="green"
                              >
                                check_circle
                              </v-icon>
                              <v-icon v-else color="red"> cancel </v-icon>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Fecha:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              {{ props.item.createdAt | dateFormat }}
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile v-if="props.item.type == 'E'">
                            <v-list-tile-content
                              >Fecha inicio:</v-list-tile-content
                            >
                            <v-list-tile-content class="align-end">
                              {{ props.item.startDate | dateFormat2 }}
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile
                            v-if="
                              props.item.type == 'E' &&
                              props.item.endDate != null
                            "
                          >
                            <v-list-tile-content
                              >Fecha término:</v-list-tile-content
                            >
                            <v-list-tile-content class="align-end">
                              {{ props.item.endDate | dateFormat2 }}
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Creador:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <img
                                    v-if="
                                      props.item.employee.img != null &&
                                      props.item.employee.img != ''
                                    "
                                    :src="
                                      'data:image/jpg;base64, ' +
                                      props.item.employee.img
                                    "
                                  />
                                  <v-icon v-else color="gray lighten-4">
                                    person
                                  </v-icon>
                                </v-avatar>
                                {{
                                  props.item.employee.firstName +
                                  ' ' +
                                  props.item.employee.lastName
                                }}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content>Rol:</v-list-tile-content>
                            <v-list-tile-content class="align-end">
                              <v-chip>
                                <v-avatar>
                                  <v-icon color="primary"> security </v-icon>
                                </v-avatar>
                                {{ props.item.employee.rol.name }}
                              </v-chip>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-expand-transition>
                    </v-card>
                  </v-hover>
                </v-flex>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
            </v-data-iterator>
          </v-flex>
          <!-- <v-flex v-show="permits['CONFIRM_NOTICE']" sm3 md2 lg2 xl2>
            <ConfirmNoticeSection
              @success="toast.success = true; getNotices();"
              @failed="toast.failed = true;"
              @watchNotice="searchNotice($event)"
              @loading="flags.loading = $event"
            ></ConfirmNoticeSection>
          </v-flex> -->
          <v-layout wrap style="height: 200px">
            <v-navigation-drawer
              v-model="drawer"
              absolute
              temporary
              right
              width="500px"
              v-if="permits['CONFIRM_NOTICE']"
            >
              <v-layout wrap style="margin: 10px">
                <v-flex xs10 class="centerContent">
                  <div class="labelTip2">
                    Comunicados pendientes por confirmar
                  </div>
                </v-flex>
                <v-flex xs2 class="centerContent">
                  <v-btn fab small color="primary">
                    <v-icon @click="drawer = false" dark small> close </v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <ConfirmNoticeSection
                    @success="
                      toast.success = true
                      getNotices()
                    "
                    @failed="toast.failed = true"
                    @watchNotice="searchNotice($event)"
                    @loading="flags.loading = $event"
                    @pendingNotices="pendingNotices($event)"
                    :reloadPendingList="reloadPendingList"
                  />
                </v-flex>
              </v-layout>
            </v-navigation-drawer>
          </v-layout>
        </v-layout>
      </v-container>
    </v-layout>
    <loading v-model="flags.loading" text="Cargando" />
    <success v-model="toast.success" text="Operación exitosa" />
    <error v-model="toast.failed" text="Ups ocurrió un error" />
    <CreateNotice
      @loading="flags.loading = true"
      @success="
        flags.loading = false
        toast.success = true
        getNotices()
      "
      @failed="
        flags.loading = false
        toast.failed = true
      "
      v-model="modals.createNotice"
    />

    <v-dialog v-model="modals2.elimina" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ modals2.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <b>{{ modals2.descripcion }}</b>
            </v-layout>
            <v-spacer />
            <v-layout class="justify-center">
              <v-btn
                color="primary darken-1"
                flat
                @click="modals2.elimina = false"
              >
                Cancelar
              </v-btn>
              <v-btn
                flat
                @click="
                  deleteNotice()
                  modals2.elimina = false
                  getNotices()
                "
              >
                Aceptar
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalCancela.elimina" persistent max-width="600px">
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">{{ modalCancela.title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-layout class="justify-center">
              <b>{{ modalCancela.descripcion }}</b>
            </v-layout>
            <v-spacer />
            <v-layout class="justify-center">
              <v-btn
                color="primary darken-1"
                flat
                @click="modalCancela.elimina = false"
              >
                No cancelar
              </v-btn>
              <v-btn
                flat
                @click="
                  cancelNotice(modalCancela.noticia)
                  modalCancela.elimina = false
                  getNotices()
                "
              >
                Si, cancelar
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <WatchNotice
      v-model="modals.watch"
      :notice="selected.wNotice"
      @reload-auth="reloadAuthNotices"
    />
    <EditNotice v-model="modals.edit" :notice="selected.eNotice" />
    <NoticeHistory v-model="modals.history" :notice="selected.eNotice" />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import error from '../../Dialogs/Error'
import loading from '../../Dialogs/Loading'
import success from '../../Dialogs/Success'
import CreateNotice from '../../Modals/CreateNotice2.vue'
import EditNotice from '../../Modals/EditNotice2'
import NoticeHistory from '../../Modals/NoticeHistory'
import WatchNotice from '../../Modals/WatchNotice2'
import ConfirmNoticeSection from '../../Sections/Notices/ConfirmationSectionNotice2'

export default {
  components: {
    success,
    error,
    loading,
    CreateNotice,
    WatchNotice,
    EditNotice,
    NoticeHistory,
    ConfirmNoticeSection,
  },
  mounted() {
    if (this.getUser.id) {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      } else {
        if (this.notices.length == 0) {
          this.getNotices()
        }
      }
    }
    this.subscribeWs()
  },
  sockets: {
    connect: function () {
      console.log('socket connected')
    },
    disconnect(evt) {
      console.log('Disconnected', evt)
    },
    reconnect() {
      console.log('Reconnected')
      this.subscribeWs()
    },
    message(notification) {
      this.updateBadge(notification)
    },
  },
  watch: {
    dates() {
      this.filters.dates = []
      for (let t of this.dates) {
        var d = new Date(t)
        this.filters.dates.push(d.getTime())
      }
    },
    pagination: {
      handler() {
        if (this.permits['WATCH_NOTICE']) this.getNotices()
      },
      deep: true,
    },
    'modals.edit': {
      handler(val, oldVal) {
        if (!val) {
          this.selected.eNotice = {
            employee: {
              rol: {},
            },
            students: [],
            levels: [],
            groups: [],
            subgroups: [],
            employeeAudience: [],
          }

          if (oldVal) {
            if (this.permits['WATCH_NOTICE']) this.getNotices()
          }
        }
      },
      deep: true,
    },
    getUser() {
      this.mapPermits()
      if (!this.permits['WATCH_NOTICE']) {
        this.toast.failed = true
      } else {
        if (this.notices.length == 0) {
          this.getNotices()
        }
      }
    },
    getBranch() {
      this.subscribeWs()
    },
  },
  filters: {
    noticeTypeFilter: function (type) {
      switch (type) {
        case 'A':
          return 'Aviso'
        case 'E':
          return 'Evento'
        case 'P':
          return 'Permiso'
        case 'R':
          return 'Aviso con confirmación'
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY')
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format('DD/MM/YYYY HH:mm')
    },
  },
  data: () => ({
    menu: false,
    dates: [],
    types: [],
    allowedDates: [],
    status: [],
    dateMenu: false,
    totalNotices: 0,
    pagination: {},
    notices: [],
    filters: {
      search: '',
      dates: [],
      typeNotice: [],
      //nuevas variables v2
      statusNotice: [],
      offset: 0,
      size: 9,
    },
    basefilters: {
      search: '',
      dates: [],
      typeNotice: [],
      statusNotice: [],
      offset: 0,
      size: 9,
    },
    flags: {
      loading: false,
    },
    toast: {
      success: false,
      failed: false,
    },
    modals: {
      title: '',
      createNotice: false,
      confirm: false,
      watch: false,
      edit: false,
      history: false,
    },
    modals2: {
      title: 'AVISO',
      descripcion: '¿ Estas seguro que deseas eliminar este comunicado ?',
      elimina: false,
    },
    modalCancela: {
      title: 'AVISO',
      descripcion: '¿ Estas seguro que deseas cancelar este comunicado ?',
      elimina: false,
      noticia: '',
    },
    selected: {
      eNotice: {
        employee: {
          rol: {},
        },
        startDate: '',
        endDate: '',
        students: [],
        levels: [],
        groups: [],
        subgroups: [],
        employeeAudience: [],
      },
      dNotice: {},
      wNotice: {
        employee: {
          rol: {},
        },
        students: [],
        levels: [],
        groups: [],
        subgroups: [],
        employeeAudience: [],
      },
    },
    permits: [],
    drawer: null,
    imgSideMenu: 'SKLB-Comunidad.png',
    connected: false,
    noticesPend: '',
    reloadPendingList: false,
    timer: undefined,
  }),
  methods: {
    clearFilter() {
      this.filters = JSON.parse(JSON.stringify(this.basefilters))
      this.getNotices()
    },
    getView() {
      return this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.smOnly
    },
    updateBadge(notification) {
      if (notification.total >= 0) {
        this.reloadPendingList = true
        this.noticesPend = notification.total
      }
    },
    pendingNotices(pendingNotices) {
      this.noticesPend = pendingNotices
      this.reloadPendingList = false
    },
    allowedDatesF(val) {
      var date = new Date(val)
      date.setSeconds(0)
      date.setMinutes(0)
      date.setHours(0)

      var flag = false
      for (let t of this.allowedDates) {
        var date2 = new Date(t)
        date2.setSeconds(0)
        date2.setMinutes(0)
        date2.setHours(0)
        if (date2.getTime() === date.getTime()) {
          flag = true
        }
      }
      return flag
    },
    mapPermits() {
      var usr = this.getUser
      var wbRol = usr.webRole
      var catalogs = wbRol.catalogs
      for (var c in catalogs) {
        if (catalogs[c].name.includes('NOTICE')) {
          this.permits[catalogs[c].name] = 1
        }
      }
    },
    clearSearch() {
      this.filters.search = ''
      this.getNotices()
    },
    filterSearch() {
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {
      // 	search: val
      // });
      this.getNotices()
    },
    filterDate() {
      // this.filters = this.$MultiFilters.updateFilters(this.filters, {
      // 	date: val
      // });
      this.getNotices()
    },
    filterType() {
      console.log('filterType')
      this.flags.loading = true
      clearTimeout(this.timer)

      const self = this
      this.timer = setTimeout(() => {
        self.flags.loading = false
        self.getNotices()
      }, 1000)
    },
    filterStatus() {
      this.flags.loading = true
      clearTimeout(this.timer)

      const self = this
      this.timer = setTimeout(() => {
        self.flags.loading = false
        self.getNotices()
      }, 1000)
    },
    getNotices() {
      this.flags.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      var pageSize =
        this.pagination.rowsPerPage == -1
          ? this.totalNotices
          : this.pagination.rowsPerPage
      var currentPage = this.pagination.page - 1
      var offset = currentPage * pageSize

      this.filters.offset = offset
      this.filters.size = pageSize
      this.$store
        .dispatch('notice/getNotices', {
          filters: this.filters,
        })
        .then((response) => {
          this.flags.loading = false
          this.notices = response.data.entity
          this.totalNotices = response.data.filters.total
          this.applyFilters(response.data.filters)
          this.$forceUpdate()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    applyFilters(newFilters) {
      if (this.filters.dates.length == 0) {
        this.allowedDates = []
        for (const [index, item] of newFilters.dates.entries()) {
          this.allowedDates.push(item)
        }
        this.$forceUpdate()
      }
      if (this.filters.statusNotice.length == 0) {
        this.status = []
        for (const [index, item] of newFilters.statusNotice.entries()) {
          switch (item) {
            case 'S':
              this.status.push({ text: 'Guardado', value: item })
              break
            case 'P':
              this.status.push({ text: 'Por autorizar', value: item })
              break
            case 'A':
              this.status.push({ text: 'Programado', value: item })
              break
            case 'R':
              this.status.push({ text: 'Rechazado', value: item })
              break
            case 'I':
              this.status.push({ text: 'Publicado', value: item })
              break
            case 'F':
              this.status.push({ text: 'Finalizado', value: item })
              break
          }
        }
        this.$forceUpdate()
      }
      if (this.filters.typeNotice.length == 0) {
        this.types = []
        for (const [index, item] of newFilters.typeNotice.entries()) {
          switch (item) {
            case 'A':
              this.types.push({ text: 'Aviso', value: item })
              break
            case 'E':
              this.types.push({ text: 'Evento', value: item })
              break
            case 'R':
              this.types.push({ text: 'Aviso con confirmación', value: item })
              break
          }
        }
        this.$forceUpdate()
      }
    },
    cancelNotice(notice) {
      this.flags.loading = true
      this.$store
        .dispatch('notice/cancelNotice', notice)
        .then(() => {
          this.flags.loading = false
          this.toast.success = true
          this.notices[this.notices.indexOf(notice)].cancelled = true
        })
        .catch((error) => {
          this.flags.loading = false
          //this.toast.failed = true;
          console.log(error)
        })
    },
    deleteNotice() {
      this.flags.loading = true
      this.$store
        .dispatch('notice/deleteNotice', this.selected.dNotice)
        .then((response) => {
          this.flags.loading = false
          this.toast.success = true
          this.getNotices()
          this.selected.dNotice = {}
        })
        .catch((error) => {
          this.flags.loading = false
          this.toast.failed = true
          console.log(error)
        })
    },
    searchNotice(notice) {
      this.$store
        .dispatch('notice/getNotice', notice.id)
        .then((response) => {
          this.viewNotice(response.data.entity)
        })
        .catch(() => {})
    },
    async viewNotice(notice) {
      const [
        { data: noticeDetail },
        { data: noticeDetailStudents },
        { data: noticeDetailAttendanceParent },
        { data: noticeDetailAttendanceStudent },
        { data: noticeDetailConfirmedParents },
      ] = await Promise.all([
        this.$store.dispatch('notice/getNoticeDetail', notice.id),
        this.$store.dispatch('notice/getNoticeDetailStudents', notice.id),
        this.$store.dispatch(
          'notice/getNoticeDetailAttendanceParent',
          notice.id
        ),
        this.$store.dispatch(
          'notice/getNoticeDetailAttendanceStudent',
          notice.id
        ),
        this.$store.dispatch(
          'notice/getNoticeDetailConfirmedParents',
          notice.id
        ),
      ])

      this.selected.wNotice = {
        ...notice,
        levels: noticeDetail.levels,
        files: noticeDetail.files,
        subgroups: noticeDetail.subgroups,
        groups: noticeDetail.groups,
        employeeAudience: [],
        students: noticeDetailStudents.data,
        parentsAttendance: noticeDetailAttendanceParent.data,
        studentsAttendance: noticeDetailAttendanceStudent.data,
        parentsConfirmed: noticeDetailConfirmedParents.data,
      }
      this.modals.watch = true
    },
    async editNotice(notice) {
      const [
        { data: noticeDetail },
        { data: noticeDetailStudents },
        { data: noticeDetailAttendanceParent },
        { data: noticeDetailAttendanceStudent },
        { data: noticeDetailConfirmedParents },
      ] = await Promise.all([
        this.$store.dispatch('notice/getNoticeDetail', notice.id),
        this.$store.dispatch('notice/getNoticeDetailStudents', notice.id),
        this.$store.dispatch(
          'notice/getNoticeDetailAttendanceParent',
          notice.id
        ),
        this.$store.dispatch(
          'notice/getNoticeDetailAttendanceStudent',
          notice.id
        ),
        this.$store.dispatch(
          'notice/getNoticeDetailConfirmedParents',
          notice.id
        ),
      ])

      this.selected.eNotice = {
        ...notice,
        levels: noticeDetail.levels,
        files: noticeDetail.files,
        subgroups: noticeDetail.subgroups,
        groups: noticeDetail.groups,
        employeeAudience: [],
        students: noticeDetailStudents.data,
        parentsAttendance: noticeDetailAttendanceParent.data,
        studentsAttendance: noticeDetailAttendanceStudent.data,
        parentsConfirmed: noticeDetailConfirmedParents.data,
      }
      // this.selected.eNotice = notice
      this.modals.edit = true
    },
    historyNotice(notice) {
      this.selected.eNotice = notice
      this.modals.history = true
    },
    handleKeyDown(e) {
      //method to handle the keypress
      if (e.code === 'Escape') {
        this.onCancel()
      }
    },
    onCancel() {
      ;(this.modals.createNotice = false),
        (this.modals.confirm = false),
        (this.modals.watch = false),
        (this.modals.edit = false),
        (this.modals.history = false)
      this.$forceUpdate()
    },
    //funciones isidoro
    deleteModalNotice() {
      this.modals2.tittle = 'AVISO'
      this.modals2.descripcion =
        '¿ Estás seguro que deseas eliminar este comunicado ?'
      this.modals2.elimina = true
    },
    cancelModalNotice(notice) {
      this.modalCancela.tittle = 'AVISO'
      this.modalCancela.descripcion =
        '¿ Estás seguro que deseas cancelar este comunicado ?'
      this.modalCancela.noticia = notice
      this.modalCancela.elimina = true
    },
    subscribeWs() {
      if (!this.connected && this.getBranch && this.getBranch.id) {
        var room = this.getRoomID(this.getBranch.id)
        this.$socket.connect()
        this.$socket.emit('subscribe', room)
        this.connected = true
      } else {
        console.log('No branch yet')
      }
    },
    getRoomID(idBranch) {
      return idBranch + '-pending-notices'
    },
    testFunc() {
      var branch = this.getBranch
      console.log(branch)
    },
    reloadAuthNotices() {
      setTimeout(() => {
        this.modals.watch = false
        this.getNotices()
      }, 2000)
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown) //will attach the event listener to the whole window when the component is created
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleKeyDown) //will detach the event listener once the component is destroyed
  },
  computed: {
    isFilterActive() {
      const base = JSON.stringify(this.basefilters)
      const currentFilter = JSON.stringify(this.filters)
      if (base !== currentFilter) {
        return true
      }
      return false
    },
    momentFormatFirst() {
      if (this.filters.date != null && this.filters.date != '') {
        return moment(this.filters.date).format('DD/MM/YYYY')
      }
      return ''
    },
    forConfirmNotices() {
      return this.notices.filter((notice) => {
        return !notice.confirm
      })
    },
    ...mapGetters(['getUser', 'getBranch']),
  },
}
</script>

<style>
.statusEvent {
  border-radius: 33px !important;
  height: 33px;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.5;
  position: absolute;
  width: 100%;
}

.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}
.expandableContainer {
  border-style: solid !important;
  border-color: #e6e6e6 !important;
  border-radius: 15px !important;
  border-width: 2px !important;
}

.v-data-iterator > .layout {
  max-height: 64vh;
  min-height: 64vh;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-color: rgba(239, 86, 91, 1) !important;
  scrollbar-color: -moz-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -webkit-gradient(
    left top,
    right top,
    color-stop(0%, rgba(239, 86, 91, 1)),
    color-stop(100%, rgba(81, 46, 111, 1))
  ) !important;
  scrollbar-color: -webkit-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -o-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: -ms-linear-gradient(
    left,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-color: linear-gradient(
    to right,
    rgba(239, 86, 91, 1) 0%,
    rgba(81, 46, 111, 1) 100%
  ) !important;
  scrollbar-width: thin;
}

.imgThumCard {
  border: 1px solid #ddd;
  /* border-radius: 4px; */
  padding: 5px;
  display: block;
  width: 90px;
  height: 90px;
  margin-top: 25px;
  margin-left: 25px;
  margin-bottom: 20px;
  border-radius: 50%;
}

.row .separatorNotice {
  background-color: #512e6f;
  height: 60px;
}

.row .separatorTittle {
  margin-top: 14px;
  margin-left: 20px;
}

.v-data-iterator > .layout::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #cccc;
  background-color: #cccc;
  border-radius: 10px;
}
.v-data-iterator > .layout::-webkit-scrollbar {
  width: 4px;
  background-color: #512e6f;
  display: block;
  opacity: 0;
}
.v-data-iterator > .layout::-webkit-scrollbar-thumb {
  background-color: #512e6f;
  border-radius: 10px;
  background-image: -webkit-linear-gradient(
    90deg,
    #ef565c 0%,
    #ef565c 25%,
    transparent 100%,
    #ef565c 75%,
    transparent
  );
}

.labelTip {
  color: rgba(115, 115, 115, 0.87);
  font-size: 1em;
  margin-top: 10px;
}

.labelTip2 {
  color: rgba(56, 56, 56, 0.87);
  font-size: 1.5em;
  /* margin-top: 10px; */
}

.greenText {
  color: rgba(28, 209, 37, 0.87);
}
.redText {
  color: rgba(255, 0, 0, 0.87);
}
.yellowText {
  color: rgba(221, 217, 0, 0.911);
}
.grayText {
  color: rgba(105, 105, 105, 0.87);
}
.orangeText {
  color: rgba(235, 97, 5, 0.87);
}

.badge {
  position: absolute;
}

.container-badge {
  position: relative;
}

.icon-abs {
  position: absolute;
}
</style>
